module.exports = require('./helpers/bundle-url').getBundleURL('jZQ3u') + "logo-dark.eefe0b7f.svg";